var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcResolucion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7915 8.375H64.2082V58.625H2.7915V8.375ZM13.9582 30.7083V36.2917H30.7082V30.7083H13.9582ZM13.9582 41.875V47.4583H53.0415V41.875H13.9582ZM46.0679 24.254L53.0415 30.0104V13.9583H39.0943V30.0104L46.0679 24.254Z",
    fill: "#285171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResolucion);
export default __webpack_public_path__ + "static/media/ic_resolucion.b9dd2c221f8ac139c5b58c28538a3736.svg";
export { ForwardRef as ReactComponent };